define('components/decorators/compute-price-checks',[
    'jquery'
],function($){
    $.extend(companyInfo.decorators, {
        'price-computation': function() {
            var $checkboxes = $(this).find("[data-checkbox-price-count]");
            var price = $(this).find("#price").val();
            $checkboxes.change(function(){
                var countCheckedCheckboxes = $checkboxes.filter(':checked').length;
                var totalPrice = countCheckedCheckboxes * price;
                $('#calculated-price').text(totalPrice.toFixed(2));
            });
        }
    });
});
